import { STORAGE_KEYS } from '@constants/storageKeys';

export function readAudioState(storage = globalThis.localStorage) {
  const saved = storage.getItem(STORAGE_KEYS.AUDIO_STATE);
  return saved ? JSON.parse(saved) : null;
}

export function writeAudioState(state, storage = globalThis.localStorage) {
  storage.setItem(STORAGE_KEYS.AUDIO_STATE, JSON.stringify(state));
}
